
















import {
    computed,
    defineComponent,
    PropType,
} from '@vue/composition-api';
import { SdsQuickLink } from '@superbet-group/web.lib.ui-components';
import { QuickLink } from './QuickLink';
import {
    useVueRouter,
    isInAppLink,
} from '@superbet-group/web.lib.vue-utilities';
import { getRoutePathFromLink } from '@superbet-group/web.lib.utilities';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import { RouteName } from '@src/app/router/constants/RouteName';
import {
    ClickName,
    ProductType,
} from '@superbet-group/product.analytics';
import { PromotionHubEntryEventLabels } from '@src/app/promotionHub/shared/types/PromotionHubEntryLabels';

export default defineComponent({
    props: {
        quickLinks: {
            type: Array as PropType<QuickLink[]>,
            required: true,
        },
    },
    setup(props) {
        const { router } = useVueRouter();

        function handleClick(quickLink: QuickLink, index: number) {
            AnalyticsSDK.getInstance().log('click', {
                click_name: ClickName.HOME_QUICK_LINK_CLICK,
                click: {
                    product_type: ProductType.SPORTS,
                    deep_link_title: quickLink.name,
                    deep_link: quickLink.link,
                    content_id: quickLink.id.toString(),
                    position: index,
                    start_time: quickLink.startDateMs,
                    end_time: quickLink.endDateMs,
                    type: 'deep_link_click',
                },
            });
            const link = quickLink.link;
            const actionType = quickLink.actionType;

            if (quickLink.name === 'quick_link.promohub') {
                AnalyticsSDK.getInstance().log(
                    'Promo_Hub',
                    {
                        eventAction: 'Entry',
                        eventLabel: PromotionHubEntryEventLabels.quickLinks,
                    },
                );
            } else if (quickLink.name === 'superspin') {
                AnalyticsSDK.getInstance().log(
                    'Game_Open',
                    {
                        game_client_id: 'superspin',
                        entry: 'Quick_Link_Sports',
                    },
                );
            }

            if (actionType === 'openInAppLink') {
                if (isInAppLink(link)) {
                    const resolvedLink = router.value.resolve(link);
                    if (resolvedLink.resolved.name === RouteName.Account.Deposit) {
                        AnalyticsSDK.getInstance().log(
                            'Deposit_Option_Chosen',
                            {
                                whichOption: 'Home_screen_quick_link',
                            },
                        );
                    }
                    router.value.push(getRoutePathFromLink(link));
                } else {
                    window.open(link, '_self');
                }
            } else {
                window.open(link);
            }
        }

        function resolveHrefForSeo(quickLink: QuickLink) {
            if (quickLink.actionType === 'openInAppLink' && isInAppLink(quickLink.link)) {
                return getRoutePathFromLink(quickLink.link);
            } else {
                return quickLink.link;
            }
        }

        return {
            isExpandedView: computed(() => props.quickLinks.length <= 4),
            handleClick,
            resolveHrefForSeo,
        };
    },
    components: {
        SdsQuickLink,
    },
});
